module.exports = __webpack_public_path__ + "img/disabledIssueMarker.e41dcab9.svg";